import React from 'react'
import logo from '../images/ic.png'
import introducing from '../images/introducing.jpg'
import preview1 from '../images/previews/_1.jpg'
import preview2 from '../images/previews/_2.jpg'
import contact from '../images/contact.jpg'
import Footer from '../components/Footer'

const APP_NAME = 'PHOTO PUZZLE'
const PARAHRAPH = 'Photo Puzzle are support both of iPad and iPhone and our app are free play life time.'
const PREVIEW_TEXT_1 = 'Free to play'
const PREVIEW_TEXT_2 = `Support both device\niPhone & iPad`
const CONTACT_DETAIL = `274 moo 7 wangwisas Trang\nafumagic3@gmail.com\n+66935761336`

const Home = () => {
  return (
    <div className="w-screen h-screen pb-60">
      <div className="container mx-auto pt-24 px-4">
        <div className="flex flex-1 flex-col justify-center items-center">
          <img className="w-48 rounded-lg" alt="logo" src={logo} />
          <h1 className="px-24 text-7xl text-gray-600 font-light my-28 text-center">INTRODUCING - {APP_NAME}</h1>
          <div
            class="bg-fixed bg-center bg-no-repeat bg-cover w-full h-96"
            style={{ backgroundImage: `url(${introducing})` }}
          />
          <h2 className="mt-28 mb-14 text-5xl text-gray-600 font-light">
            {APP_NAME}
          </h2>
          <p className="text-xl text-gray-600 font-light">
            {PARAHRAPH}
          </p>
          <h2 className="mt-28 mb-14 text-5xl text-gray-600 font-light">
            PREVIEW
          </h2>
          <div style={{ height: 500 }} className="flex mt-12 w-full">
            <div
              className="relative justify-center items-center bg-center flex flex-1 bg-black w-full h-full"
              style={{ backgroundImage: `url(${preview1})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat' }}
            >
              <div className="z-50 text-white text-2xl font-light">{PREVIEW_TEXT_1}</div>
              <div className="absolute opacity-30 text-white font-light text-3xl bg-black w-full h-full" />
            </div>
            <div className="w-24" />
            <div
              className="mt-64 relative justify-center items-center  bg-center flex flex-1 bg-black w-full h-full"
              style={{ backgroundImage: `url(${preview2})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat' }}
            >
              <div style={{ whiteSpace: 'pre-line' }} className="text-center z-50 text-white text-2xl font-light">{PREVIEW_TEXT_2}</div>
              <div className="absolute opacity-30 text-white font-light text-3xl bg-black w-full h-full" />
            </div>
          </div>
        </div>
      </div>
      <div className="mt-96 w-full h-96">
        <div className="w-full h-full mx-auto container px-4">
          <div className="bg-gray-200 flex w-full h-full">
            <div className="flex flex-1 flex-col justify-center items-center w-full h-full">
              <p className="font-extralight text-5xl text-gray-700">CONTACT US</p>
              <p style={{ lineHeight: 2, whiteSpace: 'pre-line' }} className="mt-8 font-extralight text-lg text-gray-700 text-center">
                {CONTACT_DETAIL}
              </p>
            </div>
            <div style={{ whiteSpace: 'pre-line' }} className="flex flex-1 bg-green-300 w-full h-full">
              <img className="object-cover w-full h-full" src={contact} />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default Home
